import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Domain = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Domain' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M13,3 L13,7 L13,3 Z M9,3 L9,7 L9,3 Z M5,3 L5,7 L5,3 Z M1,7 L23,7 L1,7 Z M1,21 L23,21 L23,3 L1,3 L1,21 Z' />
  </StyledIcon>
);
